<!-- focus-card/-trigger (base.scss): the header's keyboard focus outline is drawn round the whole
     card, so it grows with the card when the content is expanded. -->
<!-- The title slot is projected once here and replayed into whichever header renders (an
     <ng-content> inside @if/@else branches would only ever fill the last one). -->
<ng-template #titleContent><ng-content select="[title]"></ng-content></ng-template>

<ng-template #chevron>
  <svg aria-hidden="true" class="tw-h-7 tw-w-7 tw-text-dt-text-headings xs:tw-h-5 xs:tw-w-5">
    <use
      [attr.xlink:href]="
        'images/sprite.svg#' + (helperCollapse.isCollapsed ? expandIcon : collapseIcon)
      "
    ></use>
  </svg>
</ng-template>

<div class="focus-card tw-rounded-lg" [ngClass]="customClass">
  @if (isClickable) {
    <button
      type="button"
      [attr.aria-expanded]="!helperCollapse.isCollapsed"
      (click)="onAccordionClicked()"
      class="focus-card-trigger tw-min-h-14 tw-w-full tw-border-none tw-px-3 tw-transition-all"
    >
      <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
        <ng-container *ngTemplateOutlet="titleContent"></ng-container>
        <ng-container *ngTemplateOutlet="chevron"></ng-container>
      </div>
    </button>
  } @else {
    <!-- Only the chevron toggles here, so it is the button - the title may hold its own controls
         (e.g. a tooltip's info button), which a header <button> couldn't validly contain. -->
    <div class="tw-flex tw-min-h-14 tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-px-3">
      <ng-container *ngTemplateOutlet="titleContent"></ng-container>
      <button
        type="button"
        class="tw-flex tw-shrink-0 tw-border-none tw-bg-transparent tw-p-0"
        [attr.aria-expanded]="!helperCollapse.isCollapsed"
        [attr.aria-label]="'toggleCollapse' | i18n"
        (click)="helperCollapse.toggleContent($event)"
      >
        <ng-container *ngTemplateOutlet="chevron"></ng-container>
      </button>
    </div>
  }

  @if (!helperCollapse.isCollapsed) {
    <div class="tw-p-3">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  }
</div>
